import jobServices from 'ApiService/Placement/jobServices';
import Checkbox from 'components/checkbox';
import { AuthContext } from 'contexts/AuthContext';
import Nodatafound from 'pages/Common/Nodatafound';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { ThreeDots } from 'react-loader-spinner';
import SingleStudentData from '../SingleStudentDetail/SingleStudentData';

const AllStudents = () => {
  const { state } = useContext(AuthContext);
  const [studentDetails, setStudentDetails] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [batches, setBatches] = useState([]);
  const [branch, setBranch] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [loadingBranch, setloadingBranch] = useState(true);
  const [jobPriorityFilter, setJobPriorityFilter] = useState('all');
  const [classData, setClassData] = useState({
    courseId: '',
    batchId: '',
  });
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const branchId = selectedBranch || state?.selectedBranch || null;

  const handleCourseChange = (event) => {
    const courseId = event.target.value;
    const selectedCourse = courses.find(
      (course) => course.courseId === courseId
    );
    setBatches(selectedCourse?.batches);
    setClassData({ ...classData, courseId, batchId: '' });
  };

  const handleBatchChange = (event) => {
    const batchId = event.target.value;
    setClassData({ ...classData, batchId });
  };
  const handleBranchChange = (event) => {
    const branchId = event.target.value;
    setSelectedBranch(branchId);
    setClassData({
      courseId: '',
      batchId: '',
    });
    setBatches([]);
  };

  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await jobServices.getCourseBatch(branchId || null);

      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        setCourses([]);
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      setCourses([]);
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [branchId]);

  const fetchBranch = async () => {
    setloadingBranch(true);
    try {
      const response = await jobServices.getBranch();
      if (response.data.success) {
        const sortedBranches = (response.data.allBranches || []).sort((a, b) =>
          b.name.localeCompare(a.name)
        );
        setBranch(sortedBranches);
      } else {
        toast.error('Failed to fetch Branches.');
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch Branches.'
      );
    } finally {
      setloadingBranch(false);
    }
  };

  useEffect(() => {
    fetchBranch();
  }, []);

  useEffect(() => {
    async function fetchStudents() {
      setLoading(true);
      try {
        const requestData = {};
        if (classData.courseId) {
          requestData.courseId = classData.courseId;
        }
        if (classData.batchId) {
          requestData.batchId = classData.batchId;
        }
        if (selectedBranch) {
          requestData.branchId = selectedBranch;
        }
        const response =
          await jobServices.getPlacementReadyStudentWithPausedStudent(
            requestData.courseId,
            requestData.batchId,
            requestData.branchId
          );
        const priorityOrder = {
          High: 1,
          Medium: 2,
          Low: 3,
        };
        if (response.data.success) {
          const data = response.data.data.sort((a, b) => {
            return (
              priorityOrder[a.placementPriority] -
              priorityOrder[b.placementPriority]
            );
          });
          setStudentDetails((data || []).map((s) => ({ ...s, selected: false })));
          // setTotalPages(response.data.students.totalPages);
          setLoading(false);
          if (response.data.data.length === 0) {
            toast.error('No students found ');
          }
        } else {
          setStudentDetails([]);
          toast.error(response?.data?.message);
        }
      } catch (error) {
        setLoading(false);
        setStudentDetails([]);
        toast.error(error?.response?.data?.message);
      }
    }
    fetchStudents();
  }, [state, classData.courseId, classData.batchId, selectedBranch]);

  useEffect(() => {
    let result = [...studentDetails];

    if (searchTerm) {
      result = result.filter(
        (student) =>
          student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.contactNumber.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (filter !== 'all') {
      result = result.filter(
        (student) => student.gender.toLowerCase() === filter
      );
    }

    if (jobPriorityFilter !== 'all') {
      result = result.filter(
        (student) =>
          student.placementPriority.toLowerCase() === jobPriorityFilter
      );
    }

    setFilteredData(result);
  }, [studentDetails, filter, jobPriorityFilter, searchTerm]);

  function resetFilters() {
    setFilteredData(studentDetails);

    setClassData({
      ...classData,
      courseId: '',
      batchId: '',
    });

    setSelectedStudent(null);
    setShowDetails(false);
    setFilteredData([]);
    setFilter('all');
    setSearchTerm('');

    setSelectedBranch('');
    setJobPriorityFilter('all');
    setStudentDetails([]);
  }

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setStudentDetails((prev) =>
      prev.map((s) =>
        filteredData.some((fd) => fd._id === s._id)
          ? { ...s, selected: isChecked }
          : s
      )
    );
  };

  const handleCheckboxChange = (studentId) => {
    setStudentDetails((prev) =>
      prev.map((s) =>
        s._id === studentId ? { ...s, selected: !s.selected } : s
      )
    );
  };

  const escapeCSV = (val) => {
    const str = String(val ?? '');
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
      return '"' + str.replace(/"/g, '""') + '"';
    }
    return str;
  };

  const handleDownloadCSV = () => {
    const rows = studentDetails.filter((s) => s.selected);
    if (rows.length === 0) {
      toast.error('Please select at least one student to export.');
      return;
    }

    const header = [
      'Name',
      'Gender',
      'Email',
      'Contact Number',
      'Address',
      'Priority',
      'Location Preference',
      'Preferred Salary',
      'Education',
      'Course',
      'Batch',
      'Branch',
    ];

    const fmtAddress = (a = {}) =>
      [a.street, a.city, a.state, a.postalCode, a.country]
        .filter(Boolean)
        .join(', ');
    const currentEnrolment = (s) =>
      (s.enrollments || []).find((e) => e.current) ||
      (s.enrollments || [])[0] ||
      {};
    const fmtEducation = (records = []) =>
      records
        .map((r) => `${r.level}${r.percentage ? ` (${r.percentage}%)` : ''}`)
        .join(' | ');

    const body = rows.map((s) => {
      const enr = currentEnrolment(s);
      return [
        s.name,
        s.gender,
        s.email,
        s.contactNumber,
        fmtAddress(s.address),
        s.placementPriority,
        (s.jobLocationPreference || []).join(' | '),
        s.preferredSalary || 'Any Salary',
        fmtEducation(s.academicRecords),
        enr.course?.courseName || '',
        enr.batch?.batchNumber ?? '',
        s.branch?.name || '',
      ];
    });

    const csv = [header, ...body]
      .map((row) => row.map(escapeCSV).join(','))
      .join('\n');

    const blob = new Blob(['﻿' + csv], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `placement-ready-students-${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    toast.success('CSV downloaded successfully.');
  };

  const handleAttendanceClick = (student) => {
    setSelectedStudent(student);
    setShowDetails(true);
  };

  const handleBackClick = () => {
    setSelectedStudent(null);
    setShowDetails(false);
  };

  return (
    <div className="w-full p-4 sm:overflow-auto">
      {loading ? (
        <div className="flex h-40 w-full items-center justify-center">
          <ThreeDots color="#5431ed" className="mt-100" />
        </div>
      ) : (
        <>
          {showDetails ? (
            <SingleStudentData
              selectedStudent={selectedStudent}
              handleBackClick={handleBackClick}
            />
          ) : (
            <div extra="w-full sm:overflow-auto p-4">
              <div className="mt-2 flex w-full  items-center justify-between px-1">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                  Student Data in class {classData.std}-{classData.div}
                </div>
              </div>
              <div className="mt-2 flex w-full flex-col items-center gap-4 sm:flex-row">
                <div className="w-full rounded-xl border border-gray-200 bg-lightPrimary py-2.5 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white sm:w-full md:w-full">
                  <input
                    type="text"
                    placeholder="Search."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-800 dark:text-white"
                  />
                </div>

                <div className="w-full sm:w-[300px]">
                  <div className="w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white sm:w-full md:w-full">
                    <select
                      className="text-lightFourth w-full rounded-xl pr-4 text-sm outline-none dark:!bg-navy-800 dark:text-white"
                      value={filter}
                      onChange={(e) => setFilter(e.target.value)}
                    >
                      <option value="all">Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </div>
                </div>
                <div className="w-full sm:w-[300px]">
                  <div className="w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white sm:w-full md:w-full">
                    <select
                      className="text-lightFourth w-full rounded-xl pr-4 text-sm outline-none dark:!bg-navy-800 dark:text-white"
                      value={jobPriorityFilter}
                      onChange={(e) => setJobPriorityFilter(e.target.value)}
                    >
                      <option value="all">Job Priority</option>
                      <option value="high">High</option>
                      <option value="medium">Medium</option>
                      <option value="low">Low</option>
                    </select>
                  </div>
                </div>

                <div className="w-full sm:w-[200px]">
                  <button
                    onClick={resetFilters}
                    className="w-40 rounded-xl bg-brand-500 py-2.5 pl-2 pr-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    Reset
                  </button>
                </div>

                <div className="w-full sm:w-[200px]">
                  <button
                    onClick={handleDownloadCSV}
                    disabled={!studentDetails.some((s) => s.selected)}
                    className="w-40 rounded-xl bg-brand-500 py-2.5 pl-2 pr-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-brand-500 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    Download CSV
                  </button>
                </div>
              </div>

              <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
                {state?.user?.role === 'admin' ? null : (
                  <>
                    <div>
                      <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                        Select Branch
                      </label>
                      <select
                        onChange={handleBranchChange}
                        value={selectedBranch}
                        name="branch"
                        className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
                      >
                        <option value="">Click here to Select Branch</option>
                        {loadingBranch ? (
                          <option>Loading Branch...</option>
                        ) : branch.length === 0 ? (
                          <option className="cursor-pointer font-bold text-brand-500">
                            No Branch available
                          </option>
                        ) : (
                          branch.map((item) => (
                            <option key={item._id} value={item._id}>
                              {item.name}({item.location})
                            </option>
                          ))
                        )}
                      </select>
                    </div>
                  </>
                )}

                <div>
                  <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                    Select Course
                  </label>
                  <select
                    onChange={handleCourseChange}
                    value={classData?.courseId}
                    name="course"
                    className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
                  >
                    <option value="">Click here to Select Course</option>
                    {loadingCourses ? (
                      <option>Loading courses...</option>
                    ) : courses.length === 0 ? (
                      <option className="cursor-pointer font-bold text-brand-500">
                        No courses available
                      </option>
                    ) : (
                      courses.map((course, i) => (
                        <option key={course.courseId} value={course.courseId}>
                          {i + 1}. {course.courseName}
                        </option>
                      ))
                    )}
                  </select>
                </div>

                {/* Batch Select */}
                <div className="w-full md:w-1/2">
                  <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                    Select Batch
                  </label>
                  <select
                    onChange={handleBatchChange}
                    value={classData.batchId}
                    name="batch"
                    className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
                  >
                    <option value="">Click here to Select Batch</option>
                    {batches.length > 0 ? (
                      batches.map((batch) => (
                        <option key={batch._id} value={batch._id}>
                          Batch {batch.batchNumber} - From{' '}
                          {new Date(batch.startDate).toLocaleDateString()}
                          to {new Date(batch.endDate).toLocaleDateString()}
                        </option>
                      ))
                    ) : (
                      <option className="cursor-pointer" value="">
                        No batches available
                      </option>
                    )}
                  </select>
                </div>
              </div>
              <div className="mt-8 w-full overflow-x-auto">
                {filteredData.length === 0 ? (
                  <div className="mt-4 text-center text-gray-600 dark:text-white">
                    <p className="mt-0 text-center ">
                      {' '}
                      <Nodatafound title="No Student data found" />
                    </p>
                  </div>
                ) : (
                  <table
                    variant="simple"
                    color="gray-500"
                    mb="24px"
                    className="w-full min-w-max"
                  >
                    <thead>
                      <tr>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          <Checkbox
                            onChange={handleSelectAll}
                            checked={
                              filteredData.length > 0 &&
                              filteredData.every((s) => s.selected)
                            }
                          />
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Sr No
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Name
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Gender
                        </th>

                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Email
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Contact Number
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Address
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Priority
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Location preference
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Preferred Salary
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          View
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((student, index) => (
                        <tr
                          key={student._id}
                          onClick={() => handleAttendanceClick(student)}
                          className="cursor-pointer hover:bg-gray-50 dark:hover:bg-navy-800"
                        >
                          <td
                            className="pb-2 pl-4 pr-4 pt-2 text-center"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <Checkbox
                              checked={student.selected || false}
                              onChange={() => handleCheckboxChange(student._id)}
                            />
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {index + 1}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.name}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.gender}
                          </td>

                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.email}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.contactNumber}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.address.street}, {student.address.city},{' '}
                            {student.address.state},{' '}
                            {student.address.postalCode},{' '}
                            {student.address.country}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.placementPriority}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.jobLocationPreference.map((item) => (
                              <ul>
                                <li>{item}</li>
                              </ul>
                            ))}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm">
                            <span
                              className={`rounded-full px-2 py-1 text-xs font-semibold ${
                                student.preferredSalary === 'More than 5 LPA'
                                  ? 'bg-green-100 text-green-700'
                                  : student.preferredSalary === 'Below 5 LPA'
                                  ? 'bg-blue-100 text-blue-700'
                                  : student.preferredSalary === 'Below 4 LPA'
                                  ? 'bg-yellow-100 text-yellow-700'
                                  : student.preferredSalary === 'Below 3 LPA'
                                  ? 'bg-orange-100 text-orange-700'
                                  : 'bg-gray-100 text-gray-700'
                              }`}
                            >
                              {student.preferredSalary || 'Any Salary'}
                            </span>
                          </td>

                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white ">
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAttendanceClick(student);
                              }}
                              className="whitespace-nowrap underline dark:text-white"
                            >
                              View Assigned Jobs
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AllStudents;
